import { ExternalLink, X } from "lucide-react";
import { designDemos } from "@/data/homepageData";

export default function DemoGalleryModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="rz-modal" role="dialog" aria-modal="true" aria-labelledby="demo-modal-title">
      <div className="rz-modal__backdrop" onClick={onClose} />

      <div className="rz-modal__panel">
        <button className="rz-modal__close" onClick={onClose} aria-label="Închide">
          <X size={18} />
        </button>

        {/* <div className="rz-modal__header">
          <p className="rz-kicker rz-kicker--dark">Designuri demo</p>
          <h2 id="demo-modal-title">Aici poți prezenta mai multe direcții vizuale, fiecare cu link separat către demo.</h2>
          <p>
            Varianta asta este mai bună decât un singur link direct, pentru că le arăți rapid oamenilor că ai
            mai multe stiluri și îi lași să aleagă ce li se potrivește.
          </p>
        </div> */}

        <div className="rz-modal__grid">
          {designDemos.map((item) => (
            <article className="rz-demo-card" key={item.title}>
              <div className="rz-demo-card__image-wrap">
                <img src={item.image} alt={item.title} className="rz-demo-card__image" />
              </div>

              <div className="rz-demo-card__body">
                <div>
                  <p className="rz-demo-card__label">{item.tag}</p>
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </div>

                <a href={item.demoUrl} target="_blank" rel="noreferrer" className="rz-btn rz-btn--primary">
                  Vezi demo
                  <ExternalLink size={16} />
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
}